import type {
  Answer,
  CoverageResponse,
} from 'ts/types/coverage-questions.types';
import type {
  RemoveExtraDataFromAnswers,
  RemoveLastAnswerReturn,
} from './types';

export const answersNotAllowedToRemove = [
  'BABY',
  'DISABILITY',
  'DISTANCE_FROM_HOME_ROAD',
  'DISTANCE_TO_DESTINATION_ROAD',
  'HOUR',
  'INCIDENTS',
  'PET',
  'PREGNANT',
  'WEEKEND',
  'NUMBER_OF_PASSENGERS',
  'IMMOBILIZED_VEHICLE',
] as const;

export const getCoveredServices = (coverageResponses: CoverageResponse[]) =>
  coverageResponses.filter(({ result }) => result === 'COVERED');

export const getNotCoveredServices = (coverageResponses: CoverageResponse[]) =>
  coverageResponses.filter(
    ({ result }) => result === 'EXCLUDED' || result === 'OUT OF SCOPE',
  );

export const removeExtraDataFromAnswers: RemoveExtraDataFromAnswers = answers =>
  answers.length > 0
    ? answers.map(answer => ({
        id: answer.id,
        value: answer.value,
      }))
    : undefined;

export const isAnswerRemovable = (answers: Answer[]) => {
  const lastAnswer = answers[answers.length - 1];
  if (!lastAnswer) {
    return false;
  }
  return !answersNotAllowedToRemove.includes(lastAnswer.id as any);
};

export const removeLastAnswerFromCoverage = (
  answers: Answer[] = [],
): RemoveLastAnswerReturn => {
  if (!isAnswerRemovable(answers)) {
    return {
      answers,
      wasAnswerRemoved: false,
    };
  }
  const filteredAnswers = answers.slice(0, answers.length - 1);
  return {
    answers: filteredAnswers,
    wasAnswerRemoved: true,
  };
};
